import Button, {
  ButtonVariantEnum,
} from "@booking/components/atoms/forms/Button";
import { TextInputModeEnum } from "@booking/components/compounds/forms/TextInput";
import { SizeEnum } from "@booking/enums";
import clsx from "clsx";
import React from "react";

import { ColorEnum } from "@/enums";
import type { CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./SimplePriceFacet.module.css";

const ref = "price-facet";

interface PriceFacetProps extends Partial<CommonProps> {
  min: number;
  max: number;
  name: string;
  values: Array<number>;
  update: () => void;
  updateMin: (e: React.ChangeEvent<HTMLInputElement>) => void;
  updateMax: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function usePriceFacet(props: PriceFacetProps) {
  const {
    color = ColorEnum.DARKGREEN,
    id = createId(ref),
    min,
    max,
    name,
    values = [min, max],
    update,
    updateMin,
    updateMax,
  } = props;
  const className = clsx(styles[ref], color && styles[color], props.className);

  return {
    className,
    id,
    min,
    max,
    name,
    values,
    update,
    updateMin,
    updateMax,
  };
}

function PriceFacet(props: PriceFacetProps) {
  const {
    className,
    id,
    min,
    max,
    name,
    values,
    update,
    updateMin,
    updateMax,
  } = usePriceFacet(props);
  const maxId = `${id}_max`;
  const minId = `${id}_min`;

  return (
    <section className={className} id={id}>
      <div className={"price-input"}>
        <label htmlFor={minId}>Min</label>
        <input
          autoComplete={"off"}
          id={minId}
          inputMode={TextInputModeEnum.NUMERIC}
          placeholder={min.toString()}
          max={max}
          min={min}
          name={name}
          type={"number"}
          value={values[0] === min ? undefined : values[0]}
          onChange={updateMin}
        />
      </div>

      <div className={"price-input"}>
        <label htmlFor={maxId}>Max</label>
        <input
          autoComplete={"off"}
          id={maxId}
          inputMode={TextInputModeEnum.NUMERIC}
          placeholder={max.toString()}
          max={max}
          min={min}
          name={name}
          type={"number"}
          value={values[1] === max ? undefined : values[1]}
          onChange={updateMax}
        />
      </div>

      <Button
        color={ColorEnum.DARKGREEN}
        disabled={min === values[0] && max === values[1]}
        size={SizeEnum.SMALL}
        variant={ButtonVariantEnum.OUTLINE}
        onClick={update}
      >
        Set
      </Button>
    </section>
  );
}

export default PriceFacet;
export { PriceFacet, type PriceFacetProps };
